import type React from "react";
import { useCallback, useEffect, useRef, useState } from "react";

import type { NavigationMenuProps } from "./NavigationMenu.model";
import {
  StyledNavigationIcon,
  StyledNavigationLabel,
  StyledNavigationMenu,
} from "./NavigationMenu.styled";

export const NavigationMenu: React.FC<NavigationMenuProps> = ({ user, children }) => {
  const [showMenu, setShowMenu] = useState(false);
  const elRef = useRef<HTMLDivElement>(null);
  const onOutsideClick = useCallback((event: MouseEvent) => {
    if (!elRef.current) {
      return;
    }
    const { target } = event;
    if (target !== elRef.current && !elRef.current.contains(target as Node)) {
      setShowMenu(false);
    }
  }, []);

  useEffect(() => {
    if (showMenu) {
      window.addEventListener("click", onOutsideClick);

      return () => {
        window.removeEventListener("click", onOutsideClick);
      };
    }

    return () => {};
  }, [showMenu, onOutsideClick]);

  return (
    <StyledNavigationMenu ref={elRef} dataCy="navbar-dropdown">
      <StyledNavigationLabel data-cy="navbar-dropdown-text" onClick={() => setShowMenu(!showMenu)}>
        {user && `${user.firstName} ${user.middleName}`}
        <StyledNavigationIcon className="icon-dropdown" showMenu={showMenu} />
      </StyledNavigationLabel>
      {showMenu && children}
    </StyledNavigationMenu>
  );
};
